// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import vuetify from './plugins/vuetify';
import createStore from './store';
import Toasted from 'vue-toasted';
import moment from 'moment';
import momentTz from 'moment-timezone/builds/moment-timezone-with-data.js';
import Vuex from 'vuex';
import axios from 'axios';
import VueClipboard from 'vue-clipboard2';
import VJsoneditor from 'v-jsoneditor'

import * as localstorageUtil from './utils/localstorage';

import 'codemirror/mode/javascript/javascript.js'

import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-dark.css'

window.EventBus = new Vue();

import _axios from './axios';

_axios.get('setting').then(setting => {
  Vue.prototype.$http = axios;
  Vue.config.productionTip = false;

  Vue.use(Vuex);
  const store = createStore(setting);
  Vue.use(Toasted, { duration: 5000, keepOnHover: true, position: 'bottom-right', type: 'success' });

  router.beforeEach((to, from, next) => {
    const { setting } = store.state;
    if (to.matched.some(record => record.meta.auth)) {
      if (!localstorageUtil.getItem('token')) {
        next({
          path: '/login',
          params: { nextUrl: to.fullPath },
        });
      } else if (to.meta.settingKey && !setting[to.meta.settingKey]) {
        next({ path: '/exception-403' });
      } else {
        next();
      }
    } else {
      next();
    }
  });

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    vuetify,
    store,
  });
  Vue.filter('formatDate', function(value) {
    if (value) {
      return moment(String(value)).format('MM/DD/YYYY hh:mm:ss');
    }
  });
  Vue.filter('timezone', function(value) {
    const format = 'YYYY-MM-DD HH:mm:ss';
    let tz = setting.timezone;
    if (!setting.timezone || setting.timezone === 'BaseOnBrowser') {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return momentTz.utc(value).tz(tz).format(format);
  });
  Vue.use(VJsoneditor);
  Vue.use(VueClipboard);
});
